import { importLibrary, setOptions } from '@googlemaps/js-api-loader';

export * from './index.default';

let loadPromise: Promise<void> | null = null;
let optionsSet = false;

export function loadGeolocationLibrary(googleMapsApiKey: string): Promise<void> {
  if (loadPromise) {
    return loadPromise;
  }

  if (!optionsSet) {
    setOptions({ key: googleMapsApiKey });
    optionsSet = true;
  }

  loadPromise = importLibrary('places').then(() => undefined);
  loadPromise.catch(() => {
    // Clear cached promise so the next call can retry
    loadPromise = null;
  });
  return loadPromise;
}
